import React from "react";
import ReactDOM from "react-dom/client"; // Use React 18's createRoot
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./index.css";

// Function to notify the user about an update
const showUpdateNotification = (registration) => {
  if (window.confirm("A new version is available. Refresh to update?")) {
    // Send a message to the waiting Service Worker to skip waiting and activate
    registration.waiting.postMessage({ type: "SKIP_WAITING" });
    // Reload the page to load the new version
    window.location.reload();
  }
};

// Render the app using React 18's createRoot
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the Service Worker with the update notification callback
serviceWorkerRegistration.registerSW({
  onUpdate: showUpdateNotification,
});